"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var ra_fetch_1 = require("ra-fetch");
var storybook_1 = require("@eyecons/storybook");
function Overview(_a) {
    var _b;
    var video = _a.video, _c = _a.user, user = _c === void 0 ? {} : _c;
    var _d = ra_fetch_1.useApi('media')
        .index('comments', { video_id: video.external_id, page: 1, paginate: 10, sort: 'created_at desc' }), comments = _d[0], setComments = _d[1], commentsParams = _d[2], setCommentsParams = _d[3];
    var Request = function (page) {
        setCommentsParams(__assign(__assign({}, commentsParams), { page: page }), page !== 1);
    };
    react_1.useEffect(function () {
        if (commentsParams.video_id !== video.external_id) {
            setCommentsParams(__assign(__assign({}, commentsParams), { video_id: video.external_id }));
        }
    }, [video.external_id]);
    return react_1.default.createElement("div", { className: 'storybook-comments bg-white' },
        react_1.default.createElement("div", { className: 'storybook-comments-total mb-sm' },
            react_1.default.createElement("strong", null, (_b = comments.meta.total) !== null && _b !== void 0 ? _b : 0,
                " ",
                comments.meta.total === 1 ? 'reactie' : 'reacties')),
        user.id && react_1.default.createElement(storybook_1.Comments.Create, { user: user, video: video, comments: comments, setComments: setComments }),
        react_1.default.createElement(storybook_1.Comments.List, { user: user, video: video, comments: comments, setComments: setComments }),
        react_1.default.createElement(storybook_1.Lists.Lazyload, { loading: comments.loading, load: comments.meta.current_page !== comments.meta.last_page, onEnter: function () { return Request(comments.meta.current_page + 1); } }));
}
exports.default = Overview;
